module.exports = __webpack_public_path__ + "static/img/6400_phase_function_Paper_PointsHejduk_Prediction.b5669a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6400_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ueVi
// module chunks = 0